import type { Template } from "@/types";

export const PO_03_H0_V3: Template[] = [
{
    id: "po-03-h0v3-01",
    name: "PO 01 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 107, y: 171, width: 303, height: 512, rotation: 0, imageRotation: 0 },
            { id: "2", x: 418, y: 171, width: 302, height: 512, rotation: 0, imageRotation: 0 },
            { id: "3", x: 728, y: 171, width: 302, height: 512, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-03-h0v3-02",
    name: "PO 02 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 45, y: 137, width: 344, height: 580, rotation: 0, imageRotation: 0 },
        { id: "2", x: 397, y: 137, width: 343, height: 580, rotation: 0, imageRotation: 0 },
        { id: "3", x: 748, y: 137, width: 343, height: 580, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-03",
    name: "PO 03 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 137, width: 374, height: 580, rotation: 0, imageRotation: 0 },
        { id: "2", x: 382, y: 137, width: 373, height: 580, rotation: 0, imageRotation: 0 },
        { id: "3", x: 763, y: 137, width: 373, height: 580, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-04",
    name: "PO 04 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 30, y: 171, width: 303, height: 512, rotation: 0, imageRotation: 0 },
        { id: "2", x: 341, y: 43, width: 456, height: 768, rotation: 0, imageRotation: 0 },
        { id: "3", x: 805, y: 171, width: 303, height: 512, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-05",
    name: "PO 05 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 31, y: 0, width: 504, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 607, y: 226, width: 238, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 853, y: 226, width: 237, height: 403, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-06",
    name: "PO 06 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 165, y: 226, width: 238, height: 403, rotation: 0, imageRotation: 0 },
        { id: "2", x: 606, y: 226, width: 238, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 852, y: 226, width: 238, height: 403, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-07",
    name: "PO 07 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_07.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 165, y: 0, width: 260, height: 423, rotation: 0, imageRotation: 0 },
        { id: "2", x: 165, y: 431, width: 260, height: 423, rotation: 0, imageRotation: 0 },
        { id: "3", x: 638, y: 66, width: 427, height: 722, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-08",
    name: "PO 08 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 244, y: 69, width: 428, height: 716, rotation: 0, imageRotation: 0 },
        { id: "2", x: 680, y: 69, width: 212, height: 354, rotation: 0, imageRotation: 0 },
        { id: "3", x: 680, y: 431, width: 212, height: 354, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-09",
    name: "PO 09 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_09.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 31, y: 225, width: 248, height: 404, rotation: 0, imageRotation: 0 },
        { id: "2", x: 287, y: 225, width: 248, height: 404, rotation: 0, imageRotation: 0 },
        { id: "3", x: 638, y: 66, width: 427, height: 722, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-10",
    name: "PO 10 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 567, height: 855, rotation: 0, imageRotation: 0 },
        { id: "2", x: 624, y: 247, width: 221, height: 360, rotation: 0, imageRotation: 0 },
        { id: "3", x: 853, y: 247, width: 220, height: 360, rotation: 0, imageRotation: 0 }
    ],
}
];